import type { TemplateWithoutSections } from './useTemplates';

type DefaultableTemplate = Pick<
  TemplateWithoutSections,
  'isActive' | 'isDefault' | 'usedForAutomaticNotes'
>;

/**
 * The template we write automatic notes with after every recorded meeting. core-api decides it
 * (a firm's only active template, otherwise its active default) and marks it on the list.
 */
export function automaticNoteTemplate<T extends DefaultableTemplate>(
  templates: T[],
): T | undefined {
  return templates.find(template => template.usedForAutomaticNotes);
}

export function firmDefaultTemplate<T extends DefaultableTemplate>(templates: T[]): T | undefined {
  return templates.find(template => template.isActive && template.isDefault);
}

/** Automatic notes are paused when a firm has active templates but none of them writes them. */
export function needsDefault(templates: DefaultableTemplate[]): boolean {
  return templates.some(template => template.isActive) && !automaticNoteTemplate(templates);
}
